import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import AvatarBrown from '../../assets/images/avatar_brown.svg';

export interface RankedUser {
  id: string;
  name: string;
  points: number;
  rank: number;
}

interface RankingListItemProps {
  user: RankedUser;
}

export default function RankingListItem({ user }: RankingListItemProps) {
  const { t } = useTranslation();
  return (
    <View style={styles.container}>
      <Text style={styles.rank}>{user.rank}</Text>
      <View style={styles.avatarContainer}>
        <AvatarBrown width={40} height={40} />
      </View>
      <Text style={styles.name}>{user.name}</Text>
      <Text style={styles.points}>{t('common.pointsFull', { points: user.points })}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFF',
    paddingVertical: 12,
    paddingHorizontal: 16,
    marginBottom: 8,
    borderRadius: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
  },
  rank: {
    fontFamily: 'Inter_600SemiBold',
    fontSize: 16,
    color: '#666',
    width: 32,
  },
  avatarContainer: {
    marginRight: 12,
  },
  name: {
    fontFamily: 'Inter_600SemiBold',
    fontSize: 16,
    color: '#000',
    flex: 1,
  },
  points: {
    fontFamily: 'Inter_700Bold',
    fontSize: 14,
    color: '#D89A6A',
    marginLeft: 8,
  },
});
